var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { throttle } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';
import { Element } from 'react-scroll';
import { sleep } from '../../../../helpers/common';
import { propArrayShape, propNumber, propStr, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import { smoothScrollTo } from '../../../../helpers/ScrollUtils';
import { useLayoutDidMount } from '../../../../helpers/use/useHook';
import Image from '../../Common/Image';
const ImageSlider = (props) => {
    const { changeImageIndexMap, className, containerId, imageIndex, images, scrollingRef, slideListIndex, } = props;
    const targetId = `${containerId}_${slideListIndex}`;
    const isHorizontalImageOnly = images.length === 1 && !images[0].isVerticalImage;
    const targetRef = useRef();
    const initializeRef = useRef(false);
    /**
     * スクロール時のページ切り替え
     * @type {(function(): void)|*}
     */
    const onScroll = useMemo(() => throttle(() => {
        if (scrollingRef.current || !initializeRef.current) {
            return;
        }
        const dom = targetRef.current;
        if (dom) {
            const { height: parentHeight, top: parentTop } = dom.getBoundingClientRect();
            const parentBottom = parentTop + parentHeight;
            const childrenList = Array.from(dom.children);
            const setIndex = childrenList.findIndex((childDom) => {
                const { height, top: startPosition } = childDom.getBoundingClientRect();
                const endPosition = startPosition + height;
                const isIncludeTop = startPosition >= parentTop && startPosition <= parentBottom;
                const isIncludeBottom = endPosition >= parentTop && endPosition <= parentBottom;
                const isIncludeBoxTop = startPosition <= parentTop && endPosition >= parentTop;
                const isIncludeBoxBottom = startPosition <= parentBottom && endPosition >= parentBottom;
                return (isIncludeTop ||
                    isIncludeBottom ||
                    isIncludeBoxTop ||
                    isIncludeBoxBottom);
            });
            if (setIndex !== -1) {
                changeImageIndexMap((prev) => (Object.assign(Object.assign({}, prev), { [slideListIndex]: setIndex })));
            }
        }
    }, 300, { trailing: false }), [
        scrollingRef,
        slideListIndex,
        changeImageIndexMap,
        targetRef,
        initializeRef,
    ]);
    useEffect(() => () => {
        onScroll.cancel();
    }, [onScroll]);
    useLayoutDidMount(() => __awaiter(void 0, void 0, void 0, function* () {
        yield sleep(0.3);
        // 初期表示の段階で画面の位置を変更
        smoothScrollTo(`ImageSlider_${slideListIndex}_${imageIndex}`, {
            containerId: targetId,
            smooth: false,
            spy: true,
        });
        yield sleep(0.1);
        initializeRef.current = true;
    }));
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx("div", Object.assign({ className: clsx('slide_viewer_main_image_slider_rows', isHorizontalImageOnly && 'is-horizontal-image-only'), id: targetId, onScroll: onScroll, ref: targetRef }, { children: images.map((image, index) => (_jsx(Element, Object.assign({ className: clsx('slide_viewer_main_image_slider_col', imageIndex === index && 'is-active', image.isVerticalImage && 'is-vertical-image'), id: `ImageSlider_${slideListIndex}_${index}`, name: `ImageSlider_${slideListIndex}_${index}` }, { children: _jsx(Image, { allowContextMenu: false, alt: 'slide_viewer_main_image', isObjectFitContain: true, src: image.image, useImage: true }) }), image.id))) })) })));
};
ImageSlider.propTypes = {
    changeImageIndexMap: propFunc().isRequired,
    className: propStr().isRequired,
    containerId: propStr().isRequired,
    imageIndex: propNumber().isRequired,
    images: propArrayShape().isRequired,
    scrollingRef: propShape().isRequired,
    slideListIndex: propNumber().isRequired,
};
export default ImageSlider;
